import { type FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { type FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import type { SortingOptionsSelectFragmentFragmentDoc } from '@packages/gql/generated/shopping/SortingOptionsSelectFragmentFragmentDoc';
import { Select, SelectContent, SelectItem } from '@packages/shared/src/ui/Select/Select';
import { useSorting } from '../../hooks/useSorting';

/* GraphQL */ `
  fragment SortingOptionsSelectFragment on SearchFilterableAndSortableResult {
    ...UseSortingFragment
    availableSortingOrders {
      key
      displayName
    }
  }
`;

const messages = defineMessages({
  sortingModeLabel: {
    id: 'search.productList.displaySettings.sortingMode.label',
    defaultMessage: 'Sortieren',
  },
});

export type SortingOptionsSelectProps = {
  maskedData: FragmentType<typeof SortingOptionsSelectFragmentFragmentDoc>;
};

export const SortingOptionsSelect: FC<SortingOptionsSelectProps> = ({ maskedData }) => {
  const { formatMessage } = useIntl();

  const data = unmask<typeof SortingOptionsSelectFragmentFragmentDoc>(maskedData);

  const { sortingKey, pushSortingChange } = useSorting(data);

  const sortingItems = data.availableSortingOrders.map(({ key: value, displayName: label }) => ({
    value,
    label,
  }));

  return (
    <Select
      value={sortingKey}
      onValueChange={(event) => {
        pushSortingChange(event);
      }}
      id={formatMessage(messages.sortingModeLabel).toLowerCase()}
      label={formatMessage(messages.sortingModeLabel)}
    >
      <SelectContent sideOffset={-8} className="z-modal">
        {sortingItems.map(({ value, label }) => (
          <SelectItem key={value} value={value}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
